import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { IBreadcrumb } from './breadcrumbs/breadcrumbs.component';

export interface IBreadcrumbsState {
  breadcrumbs: IBreadcrumb[];
}

const initialState: IBreadcrumbsState = {
  breadcrumbs: [],
};

@Injectable()
export class BreadcrumbsStore extends ComponentStore<IBreadcrumbsState> {
  readonly breadcrumbs$ = this.select((state) => state.breadcrumbs);

  readonly setBreadcrumbs = this.updater(
    (state, breadcrumbs: IBreadcrumb[]) => ({
      ...state,
      breadcrumbs,
    })
  );

  constructor() {
    super(initialState);
  }
}
